import styled from 'styled-components'
import {
  OUTLINE_COLOR, SITE_NAVY_COLOR,
  GREY_BACKGROUND, SELECTED_ITEM_BG_COLOR, FONT_BASE_COLOR,
} from '@CSSVars/colors'
import { BREAK_POINT_SM, BREAK_POINT_LG } from '@CSSVars/variables'


export const _ChildAreaBox = styled.button`
  position: relative;
  display: inline-flex !important;
  padding: 13px 24px;
  text-align: center;
  border: 1px solid ${OUTLINE_COLOR};
  line-height: 22px;
  margin: 4px;
  white-space: nowrap;
  border-radius: 10px;
  min-height: 44px;
  font-size: 14px;
  @media screen and (min-width: ${BREAK_POINT_LG}) {
    @media (hover: hover) and (pointer: fine) {
      &:hover {
        cursor: pointer;
        background: ${GREY_BACKGROUND};
        ${({ selected }) => (selected ? `div { color: ${FONT_BASE_COLOR};}` : '')};
      }
    }
  }
  background: ${({ selected }) => (selected ? SITE_NAVY_COLOR : 'initial')};
  flex-wrap: ${({ selected }) => (selected ? 'nowrap' : '')};
  ${({ selected }) => (selected ? 'div { color: white;}' : '')};
  @media screen and (max-width: ${BREAK_POINT_SM}) {
    white-space: initial;
    display: flex !important;
    width: calc(50% - 8px);
    justify-content: center;
    align-items: center;
    > div {
      line-height: 18px;
    }
  }
  &:active{
    background: ${SELECTED_ITEM_BG_COLOR};
    div {
      color: white;
    }
  }
`

export const _CloseBtn = styled.div`
  position: absolute;
  right: 8px;
  top: 4px;
  svg {
    fill: white;
  }
`
